import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

// Selectors
import * as OnboardingStateSelectors from 'Shared/selectors/OnboardingState.selectors';

// Components
import Terminal from '../OnboardingWizard/Terminal/Terminal';
import { WpPageLayout, WpPageHeader, WpPageTitle, WpPageBody } from 'Wpds/components/page-layout';
import { WpSteps, WpStep } from 'Wpds/components/steps';
import WpAvatar from 'Wpds/components/avatar/WpAvatar';
import AboutYou from './AboutYou/AboutYou';
import NextMeeting from './NextMeeting/NextMeeting';
import CreateMeetingAgenda from './CreateMeetingAgenda/CreateMeetingAgenda';

// Hooks
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

const OnboardingPage = () => {
  const { user } = useCurrentUser();
  const flowType = useSelector(state => OnboardingStateSelectors.getFlowType(state));
  const stepIndex = useSelector(state => OnboardingStateSelectors.getStepIndex(state));
  const step = useSelector(state => OnboardingStateSelectors.getStep(state));
  const recurringMeetings = useSelector(state => OnboardingStateSelectors.getRecurringMeetings(state));
  const connectedCalendar = useSelector(state => OnboardingStateSelectors.getConnectedCalendar(state));
  const hasRecurringMeetings = recurringMeetings.length > 0;

  const [activeStep, setActiveStep] = useState(stepIndex);

  useEffect(() => {
    setActiveStep(stepIndex);
  }, [stepIndex]);

  const baseClassName = 'OnboardingPage';

  if (step === 'terminal') {
    return <Terminal />;
  }

  return (
    <WpPageLayout className={baseClassName} width="container">
      <WpPageHeader>
        <WpPageTitle
          title="Welcome to PI Perform!"
          subTitle="You're on your way to great meetings. Let's get your first 1:1 meeting workspace set up."
          prefix={<WpAvatar avatar={user.avatar} size="xl" />}
        />
      </WpPageHeader>
      <WpPageBody>
        <WpSteps activeStepNumber={activeStep} hideDefaultNavButtons>
          <WpStep title="About you">
            <AboutYou />
          </WpStep>
          {flowType === 'magic_one_on_one' && (
            <>
              <WpStep
                title="Who is your next 1:1 with?"
                subTitle={
                  hasRecurringMeetings &&
                  connectedCalendar &&
                  'We found recurring meetings in your calendar. Select at least one to create a collaborative workspace with your teammate(s).'
                }
              >
                <NextMeeting />
              </WpStep>
              <WpStep
                title="Create Meeting Agenda"
                subTitle="Select suggested topics to start building your agenda, or add your own! "
              >
                <CreateMeetingAgenda />
              </WpStep>
            </>
          )}
        </WpSteps>
      </WpPageBody>
    </WpPageLayout>
  );
};

export default OnboardingPage;
